import styled from 'styled-components'

export const AreaText = styled.div`
  font-size: ${(props) => props.theme.widgets.hotspot.areaTextFontSize};
  font-weight: ${(props) => props.theme.widgets.hotspot.areaTextFontWeight};
`
